import { render, staticRenderFns } from "./NavBarDesktop.vue?vue&type=template&id=fc03a1e2"
import script from "./NavBarDesktop.js?vue&type=script&lang=js&external"
export * from "./NavBarDesktop.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports